//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  props: {
    sku: { type: String, required: true },
    secondarySku: { type: String, default: null },
    productDetails: { type: Object, required: true },
    baseSku: { type: String, required: true },
    productName: { type: String, required: true },
    leMode: { type: Boolean, default: false },
    lePartMode: { type: Boolean, default: false },
    preorder: { type: Boolean, required: true },
    preorderDate: { type: Number, default: -1 },
    ecomProduct: { type: Object, required: true },
    legacyProduct: { type: Boolean, required: true },
    showLandingPageLink: { type: Boolean, required: true },
    inTheBoxItems: { type: Array, default: () => ([]) },
    useGenericReviews: { type: Boolean, default: false },
    conversionKitEnabled: { type: Boolean, required: true }
  },
  data () {
    return {
      activeItem: null,
      showCountryDropdown: false
    }
  },
  computed: {
    ...mapGetters({
      showKlarnaMessaging: 'store/showKlarnaMessaging',
      shippingCountryName: 'store/shippingCountryName',
      shippingDetails: 'store/shippingDetails',
      isDomesticShipping: 'store/isShippingDomestic',
      getProductName: 'product/productName'
    }),
    reviewSummary () {
      return this.useGenericReviews
        ? this.$store.getters['review/summary']
        : this.$store.getters['review/productSummary'](this.baseSku)
    },
    shippingCost () {
      if (this.isDomesticShipping) return this.shippingDetails.domesticCost
      return this.shippingDetails.internationalCost
    },
    skuPrefix () {
      return this.sku.split('-')[0]
    },
    items () {
      return this.inTheBoxItems.map(item => ({
        img: item.image.url,
        ...item
      }))
    },
    isKlarnaAvailable () {
      return (this.storeCurrency === 'GBP' && this.storeCountry === 'GB') ||
        (this.storeCurrency === 'EUR' && this.storeCountry === 'DE')
    },
    delayedDespatchDate () {
      return this.$store.getters['product/delayedDespatchDate'](this.sku)
    }
  },
  methods: {
    toggle (section) {
      this.activeItem = this.activeItem === section ? null : section
      this.$store.dispatch('session/TRACK', { event: 'PP_TOGGLE_ACCORDIAN', sku: this.sku, body: section })
    }
  }
}
